import React, { Component } from 'react';
import {
    Route,
    Routes,
    Outlet,
    Navigate,
    useLocation
} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { LayoutWithMenu } from './LayoutWithMenu';
import { LoginWithNavigate } from './components/Login';
import { NavMenu } from './components/NavMenu'
import User from './components/User'
import './custom.css';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedIn: User.isLoggedIn(),
        };
    }

    static displayName = App.name;

    componentDidMount() {
        this.setState({ loggedIn: User.isLoggedIn() });
    }

    render() {
        return (
            <LayoutWithMenu>
                <Routes>
                    <Route path='/login' element={<LoginWithNavigate />} />
                    <Route element={<PrivateOutlet />}>
                        {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                        })}
                    </Route>
                </Routes>
            </LayoutWithMenu>
        );
    }
}

function PrivateOutlet() {
    const auth = User.isLoggedIn();
    const location = useLocation();

    return auth ? (
        <Outlet />
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
}

